import { CommonService } from "../../services/common/commonService";
import { Outlet, Link } from "react-router-dom";
import CompanyLogo from "../common/CompanyLogo";
import { IconBrandFacebookFilled } from "@tabler/icons-react";
import { AuthService } from "../../services/auth/authService";
import { UserService } from "../../services/user/userService";
import { useNavigate } from "react-router-dom";

const DeliveryLayout = () => {
  const navigate = useNavigate();
  return (
    <>
      <AuthService>
        <UserService>
          <CommonService>
            <div className='admin-wrapper min-h-svh py-6 px-4 flex items-center justify-center bg-body-color after:fixed after:w-full after:h-full after:start-0 after:top-0 after:opacity-90 after:bg-[url("../../assets/images/auth.png")]'>
              <div className="container-fluid">
                <div className="flex gap-15 w-full relative z-[1]">
                  <div className="w-1/4 flex justify-center">
                    <div className="items-center justify-center w-full lg:flex hidden">
                      <div className="max-w-[400px]">
                        <div
                          className="mb-4"
                          onClick={() => navigate("/")}
                          style={{ cursor: "pointer " }}
                        >
                          <CompanyLogo className="text-primary w-[256px] h-auto" />
                        </div>
                        <p className="mb-12 text-[32px]/[40px] font-medium">
                          საფოსტო საკურიერო სერვისი
                        </p>
                        <div className="mb-8">
                          <p className="text-[24px]/[30px] mb-2">
                            საფოსტო საკურიერო სერვისი საქართველოს მასშტაბით.
                          </p>
                          <p>ექსპრეს მიწოდება საქართველოს ყველა რეგიონში</p>
                        </div>
                        <div className="flex flex-wrap gap-4 mb-4">
                          <Link
                            to="/"
                            className="transition-all hover:text-primary"
                          >
                            მთავარი
                          </Link>
                          <Link
                            to="/contact"
                            className="transition-all hover:text-primary"
                          >
                            კონტაქტი
                          </Link>
                          <Link
                            to="/faq"
                            className="transition-all hover:text-primary"
                          >
                            FAQs
                          </Link>
                        </div>
                        <div className="flex flex-wrap gap-4">
                          <Link
                            to="https://www.facebook.com/Geoexpress.ge/"
                            target="_blank"
                            className="w-[34px] h-[34px] rounded-full bg-border-color flex items-center justify-center text-white transition-all hover:bg-secondary"
                          >
                            <IconBrandFacebookFilled width="18" height="18" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
<div className="flex items-center justify-center w-full max-w-7xl">
  <div className="bg-card-color rounded-xl sm:p-4 p-2 w-full shadow-shadow-sm border border-dashed border-border-color">
    <div className="sm:p-4 p-3 overflow-auto custom-scrollbar">
      <Outlet />
    </div>
  </div>
</div>
                </div>
              </div>
            </div>
          </CommonService>
        </UserService>
      </AuthService>
    </>
  );
};

export default DeliveryLayout;
